import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,handleTokenExpiry,isEmptyVariable} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {DialogSaveButton} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();


class AddIndustryDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,

            industryName:"",
            industryShortName:"",
            formErrors:{},
            submitClickedAtleastOnce:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showCreateDialog){
            if(this.props.isEdit){
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    industryName:this.props.industryName,
                    industryShortName:isEmptyVariable(this.props.industryShortName)?"":this.props.industryShortName,
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }else{
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    industryName:"",
                    industryShortName:"",
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleCreateMaster();
        }
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    handleCreateDialogClose = () =>{
        this.props.handleAddEditDialogClose(false);
    }

    handleCreateMaster = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.industryName)){
            isError = true;
            FormErrorsTemp['industryName'] = "Please enter industry name";
        }

        if(isEmptyVariable(this.state.industryShortName)){
            isError = true;
            FormErrorsTemp['industryShortName'] = "Please enter industry short name";
        }
        
        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

        }else{
            let url = "";
            let postParam = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            }

            if(this.props.isEdit){
                url = Constants.UpdateIndustry;
                let industryObj = {
                    industryId:this.props.selectedId,
                    industryName:this.state.industryName,
                    industryShortName:this.state.industryShortName
                }
                postParam.industry = JSON.stringify(industryObj);
                postParam.rootIndustryId = this.props.rootIndustryId;
            }else{
                postParam.departmentId = this.props.departmentId;
                if(this.props.createNodeType === "root"){
                    url = Constants.AddRootIndustry;
                    let industryObj = {
                        industryId:0,
                        industryName:this.state.industryName,
                        industryShortName:this.state.industryShortName
                    }
                    postParam.industry = JSON.stringify(industryObj);

                }else if(this.props.createNodeType === "child"){
                    url = Constants.AddChildIndustry;
                    let industryObj = {
                        industryId:0,
                        industryName:this.state.industryName,
                        industryShortName:this.state.industryShortName
                    }

                    postParam.childIndustry = JSON.stringify(industryObj);
                    postParam.parentIndustryId = this.props.relativeIndustryId;
                    postParam.rootIndustryId = this.props.rootIndustryId;
                    
                }else if(this.props.createNodeType === "sibling"){
                    url = Constants.AddSiblingIndustry;

                    let industryObj = {
                        industryId:0,
                        industryName:this.state.industryName,
                        industryShortName:this.state.industryShortName
                    }

                    postParam.siblingIndustry = JSON.stringify(industryObj);
                    postParam.targetIndustryId = this.props.relativeIndustryId;
                    postParam.rootIndustryId = this.props.rootIndustryId;
                }
            }

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParam)
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    let createNodeTypeTemp = this.props.createNodeType;

                    if(createNodeTypeTemp === "root"){
                        this.setState({
                            showLoader:false,
                            industryName:"",
                            industryShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }else if(createNodeTypeTemp === "child" ||
                    createNodeTypeTemp === "sibling"){
                        this.setState({
                            showLoader:false,
                            industryName:"",
                            industryShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }
                }else{
                    this.setState({
                        showLoader:false,
                        showAlertDialogInfo:true,
            			alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }
    }

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showCreateDialog} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.isEdit?"Edit Industry":"Add Industry"}</h5>
                    <button 
                        onClick={this.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div class="modal-body">
                    {
                        this.state.showLoader &&
                        <div class="loader"></div>
                    }
                    <div class="addnew-modal-form">
                        <div class="addnew-modal-form-group">
                            <p>Industry Short Name*</p>
                            <input type="text" placeholder="Enter Industry Short Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="industryShortName" value={this.state.industryShortName} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['industryShortName']) &&
                                <span class="cm-error">{this.state.formErrors['industryShortName']}</span>
                            }
                        </div>
                        <div class="addnew-modal-form-group">
                            <p>Industry Name*</p>
                            <input type="text" placeholder="Enter Industry Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="industryName" value={this.state.industryName} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['industryName']) &&
                                <span class="cm-error">{this.state.formErrors['industryName']}</span>
                            }
                        </div>
                    </div>
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton
                            themeSettings={this.props.themeSettings}
                            onClick={this.handleCreateMaster} type="button">Save</DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                themeSettings={this.props.themeSettings}
            />
            </>
        );
    }
}

export default AddIndustryDialog;